import { useEidModel } from "@/models"
import Verity from "../Verity"
import "./index.scss"
function VerityBox() {
  const { eid, setAllState } = useEidModel()
  // 验证图形的callback
  const verityCallback = (res: boolean) => {
    if (res) {
      setAllState((prev) => ({
        eid: "",
        refreshCount: (prev.refreshCount || 0) + 1,
      }))
    }
  }
  if (!eid) return null
  return (
    <div className="verity-box">
      <Verity eid={eid} onSuccess={verityCallback} />
      <div className="verity-box-shadow" />
    </div>
  )
}
export default VerityBox
